module.exports = __webpack_public_path__ + "static/media/C_S02.ae494ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/C_S02.png
// module id = 76
// module chunks = 0